import { render, staticRenderFns } from "./wabaChannels.vue?vue&type=template&id=88368638&"
import script from "./wabaChannels.vue?vue&type=script&lang=ts&"
export * from "./wabaChannels.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports